export { EmployeeEntity } from './employee.entity';
export { EmployeeEntityList } from './employee.entity-list';

export type { Entity as StudentEntityType } from './employee.entity';
